import React from "react"

import creativityIcon from "../../images/creativity-v2.png"
import communityIcon from "../../images/community-v2.png"
import challengeIcon from "../../images/challenge-v2.png"

import styles from "./about.module.css"

const About = () => {
  return (
    <div className={styles.Wrapper} id="about">
      <div className={styles.Container}>
        <p className={styles.AboutIntro}>
          Be empowered to create and control your own fitness regimen.
        </p>

        <div className={styles.ValuePropsWrapper}>
          <div className={`${styles.Main} ${styles.Creativity}`}>
            <div className={styles.ImgWrapper}>
              <img src={creativityIcon} alt="Creativity icon" />
            </div>
            <div className={styles.MainCopy}>
              <h2>Creativity</h2>
              <p>
                Create your own workout routines to help you continuously
                progress through your fitness journey, whatever your goals are.
              </p>
            </div>
          </div>
          <div className={`${styles.Main} ${styles.Community}`}>
            <div className={styles.ImgWrapper}>
              <img src={communityIcon} alt="Community icon" />
            </div>
            <div className={styles.MainCopy}>
              <h2>Community</h2>
              <p>
                Share your workouts with friends, on and off the app, and join a
                community of other Flex users with similar fitness goals.
              </p>
            </div>
          </div>
          <div className={`${styles.Main} ${styles.Challenge}`}>
            <div className={styles.ImgWrapper}>
              <img src={challengeIcon} alt="Challenge icon" />
            </div>
            <div className={styles.MainCopy}>
              <h2>Challenge</h2>
              <p>
                Challenge your friends or join challenges within the Flex
                community. Encourage each other and reach your goals together.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About
